// Generated from b2bservices/src/common/productRequirements/validators.ts.
// Do not edit. Run yarn requirements:sync in a paired checkout.

import type { ProductFieldValidatorParams, ProductValues } from './types';

export const isBlank = (value: unknown) => value == null || (typeof value === 'string' && value.trim() === '');
export const hasNutritionalValue = (value: unknown) => typeof value === 'number' || (typeof value === 'string' && value.trim() !== '');
export const REQUIRED_NUTRITIONAL_FIELDS = ['energi_kj', 'energi_kcal', 'fett', 'mattatFett', 'kolhydrat', 'sockerarter', 'protein', 'salt'] as const;
export const VITAMIN_MINERAL_FIELDS = ['vitaminA', 'vitaminD', 'vitaminE', 'vitaminK', 'vitaminC', 'tiamin', 'riboflavin', 'niacin', 'vitaminB6', 'folsyra', 'vitaminB12', 'biotin', 'pantotensyra', 'kalium', 'klorid', 'kalcium', 'fosfor', 'magnesium', 'jarn', 'zink', 'koppar', 'mangan', 'fluorid', 'selen', 'krom', 'molybden', 'jod'];
export const getRequiredNutritionalFields = (state?: ProductValues) =>
  REQUIRED_NUTRITIONAL_FIELDS.some(field => hasNutritionalValue(state?.[field])) ? [...REQUIRED_NUTRITIONAL_FIELDS] : [];
export const getMissingNutritionalFields = (state?: ProductValues) =>
  getRequiredNutritionalFields(state).filter(field => !hasNutritionalValue(state?.[field]));

export const requireBooleanValidator = ({ state, field }: ProductFieldValidatorParams) => {
  const value = state?.[field];
  return value === true || value === false || value === 'true' || value === 'false';
};
export const requireEnumValidator = ({ state, field }: ProductFieldValidatorParams) => !isBlank(state?.[field]);
export const requireStringValidator = requireEnumValidator;
export const requireNumberValidator = ({ state, field }: ProductFieldValidatorParams, options?: { greaterThanZero?: boolean }) => {
  const value = state?.[field];
  if (isBlank(value)) return false;
  if (options?.greaterThanZero) {
    const amount = Number(String(value).replace(',', '.'));
    return Number.isFinite(amount) && amount > 0;
  }
  return true;
};

export const getFormattedValue = (value?: number | string) => {
  if (typeof value === 'number') return value < 0 ? value.toString() : '+' + value.toString();
  if (typeof value === 'string') return value && !value.includes('+') && !value.includes('-') ? '+' + value : value;
  return '';
};
export const hasTemperatureValue = (value: unknown) =>
  (typeof value === 'number' || typeof value === 'string') && getFormattedValue(value) !== '';
export const getTemperatureError = (minValue?: number, maxValue?: number) => {
  const hasMin = hasTemperatureValue(minValue), hasMax = hasTemperatureValue(maxValue);
  if (hasMin && hasMax && minValue! > maxValue!) {
    return { message: 'Högsta temperatur kan inte vara lägre än lägsta temperatur', min: true, max: true };
  }
  if (hasMin !== hasMax) return { message: 'Fill required temperature fields', min: !hasMin, max: !hasMax };
  return undefined;
};
